import styled from "styled-components";

import color from "constants/color";

const Label = styled.div<{ active: boolean }>`
  color: ${({ active }) => (active ? color.text : color.border)};
`;

const Badge = styled.span<{ active: boolean }>`
  background-color: ${({ active }) => (active ? color.attention : color.border)};
  width: 8px;
  height: 8px;
  border-radius: 50%;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const NotificationHomeDisplaySwitcher = ({ homeDisplay }: { homeDisplay: boolean }) => {
  return (
    <Wrap>
      <Badge active={homeDisplay} />
      <Label active={homeDisplay}>{homeDisplay ? "表示する" : "表示しない"}</Label>
    </Wrap>
  );
};
export default NotificationHomeDisplaySwitcher;
